import React, { Fragment, useRef, useState } from "react"
import { Modal, ModalHeader, ModalFooter, Button, ModalBody } from "reactstrap"
import { ModalContainerProps } from "./_ModalContainer"
import { joinLines } from 'web/utils/utils'
import { getCurrentBuild } from 'web/data/core-data'

export const NewPatchInfoModal: React.FC<ModalContainerProps> = ({ closeSelf }) => {

    // Always runs against current build
    const buildData = getCurrentBuild()

    const [confirmText, setConfirmText] = useState("I've read and understood the warning")
    const cycleRef = useRef<number>(0)

    const cycleConfirm = () => {
        if (cycleRef.current === 0) {
            setConfirmText('Did you really read it though?')
        }

        if (cycleRef.current === 1) {
            setConfirmText('Ok, last chance')
        }

        if (cycleRef.current === 2) {
            setConfirmText(`After this one, you're on your own!`)
        }

        if (cycleRef.current >= 3) {
            closeSelf()
        }

        cycleRef.current++
    }

    return (
        <Modal
            isOpen
            fade={false}
        >
            <ModalHeader>
                {"Important — Breaking changes!"}
            </ModalHeader>

            <ModalBody className="p-3 m-0 bg-light">

                <p>
                    {joinLines([
                        "Due to changes made to the game, some old spells and talents",
                        "may no longer work like they used to. Because of this, all the setups",
                        "created for the previous build are now in a read-only mode and can",
                        "no longer be modified.",
                    ])}
                </p>

                <p>
                    {joinLines([
                        "You should also look over your roster, as some players might have",
                        "lost spells or talents there. Some players might have also been",
                        "completely removed if Blizzard removed all of their utility."
                    ])}
                </p>

                <p>
                    {joinLines([
                        "These changes only apply to assigned spells, so all of your fight",
                        "outlines should be unchanged."
                    ])}
                </p>

                <label className="small font-weight-bold">{"Changelog"}</label>
                <div
                    className="small border bg-white p-2 text-monospace"
                    style={{
                        maxHeight: "300px",
                        overflowY: "scroll"
                    }}
                >
                    {buildData.changelog?.map(change => {
                        return (
                            <Fragment key={change}>
                                {change}
                                <br />
                            </Fragment>
                        )
                    })}
                </div>

            </ModalBody>

            <ModalFooter className="d-flex justify-content-end space-mx-2" >
                <Button outline size="sm" onClick={cycleConfirm}>
                    {confirmText}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
